import { Dynamic } from "../../../controllers/conductor";
import { getController } from "../../../controllers/getter";
import { AlertDrawer } from "../../sections/sidebar/AlertDrawer";
import { LoadingAnimation } from "../../widgets/loading";
import { MainWindow } from "../MainWindow";
import { Button, IconButton } from "../../widgets/buttons";
import { ScrollingTable } from "../../widgets/table";
import { Blocker } from "../../widgets/misc";
import { LocationSelector } from "../../widgets/form";
import { AccountsController } from "../../../controllers/Accounts";
import { ApprovalIcon } from "../../widgets/approval";

import "../../../styles/pages/accounts.css";
import "../../../styles/widgets/widgets.css";

import Client from "../../../Client";
import { listRoleOptions } from "../../../misc/account";

import React from "react";
import { Dropdown } from "../../widgets/input";

function Accounts() {

    const ref = { filters: { page: 1, pageSize: 10 } };

    const controller = getController(AccountsController, { ref });
    // if(controller.isInitialized) controller.changeDate(ref.month, ref.year);

    const { notifiers, status } = controller;
    
    return (<MainWindow currentTab="accounts">
        <Dynamic conductor={[ notifiers.ready, notifiers.unauthorized ]} child={()=>
            status.unauthorized ? <Unauthorized /> : status.ready ? <Main controller={controller} /> : <LoadingWindow />
        } />
    </MainWindow>);
}

function Unauthorized() {
    return <div>Unauthorized</div>;
}

function LoadingWindow() {
    return (<center><LoadingAnimation /> Loading...</center>);
}


function Main({ controller }) {
    return <div className="form-main accounts">
        <div className="alert-drawer-wrapper"><AlertDrawer controller={controller.notifiers.alert} /></div>
        <Header controller={controller} />
        <ListSection controller={controller}/>
        <Pagination controller={controller} />
        <Footer controller={controller} />
    </div>;
}


function Header({ controller }) {
    
    const patternRef = React.createRef();
    const rolesOptions = [{ label: "All Roles" }, ...listRoleOptions() ];
    const confirmedOptions = [
        { label: "Confirmed / Not" },
        { label: "Confirmed", value: true },
        { label: "Not Confirmed", value: false },
    ];

    const filters = {};

    const search = () => {
        filters.pattern = patternRef.current?.value || "";
        controller.search(filters);
    };
    
    return <header>
        <div>
            <h2>Accounts</h2>
        </div>
        <div className="buttons">
            <Dropdown options={confirmedOptions} onSelect={(confirmed) => filters.confirmed = confirmed } />
            <Dropdown options={rolesOptions} onSelect={(role) => filters.role = role } />
            <input className="input" ref={patternRef} placeholder="Search for a name"/>
            <Button color="blue" icon="filter" onClick={search}>FILTER</Button>
        </div>
    </header>;
}



function ListSection({ controller }) {
    const columns = [
        { title: "FULL NAME", width: "30%" },
        { title: "USERNAME", width: "17%" },
        { title: "ROLE", width: "28%" },
        { title: "", width: "25%" },
    ];

    const { notifiers, status } = controller;

    return <main>
        <Dynamic conductor={notifiers.reloaded} child={()=>{
            const { data } = controller;

            const accounts = data.results;

            if(accounts.length === 0) return <center>No results found.</center>;

            const rows = accounts.map((account, ai) => {
                const { id, fullname, username, role_semantic, confirmed } = account;

                const you = Client.account.id === id;
                const fullnameDisplay = you ? <span key="1">{fullname} <span className="subtext-1">(YOU)</span></span> : fullname;
                return [
                    fullnameDisplay, username, 
                    <span key="2">{role_semantic.title} {role_semantic.specific ? <span className="subtext-2">({role_semantic.specific})</span> : ""}</span>,
                    <div key="3" className="account-controls">
                        {!confirmed ? <Button className="confirm-btn" onClick={()=>controller.confirmAccount(account)}>CONFIRM</Button> : ""}
                        <IconButton size="30" icon="edit" onClick={()=>controller.editAccount(account)} /> &nbsp; &nbsp; 
                        <IconButton size="30" icon="cancel" onClick={()=>controller.deleteAccount(account)} />
                    </div>
                ];
            });

            return <ScrollingTable columns={columns} rows={rows} />;
        }} />
        <Dynamic conductor={notifiers.reloading} child={()=>
            <Blocker active={status.reloading}><center><LoadingAnimation />Loading data...</center></Blocker>
        } />
    </main>
}

function Pagination({ controller }) {
    const { reloaded, reloading } = controller.notifiers;
    const maxVisibleButtons = 5;

    const ellipsis = () => <div className="ellipsis" key={Math.random()}>...</div>;

    return <Dynamic conductor={[reloaded, reloading]} child={()=>{
        
        const preselectedPage = controller.reference.filters.page;

        const { page, pageSize, maxPages, matchedTotal } = controller.data;
        const range = `${(page-1)*pageSize + 1} - ${Math.min(page*pageSize, matchedTotal)}`;


        const startPageButton = maxPages <= maxVisibleButtons || preselectedPage < maxVisibleButtons - 2 ? 1 : 
            preselectedPage + 2 < maxPages ? preselectedPage - maxVisibleButtons + 3 : 
            maxPages - maxVisibleButtons + 1 ; 

        const endPageButton = Math.min(startPageButton + maxVisibleButtons - 1, maxPages);

        const buttons = [];

        for(let p = startPageButton; p <= endPageButton; p++) {
            const active = p === preselectedPage;
            const pageButton = <Button key={p} onClick={() => controller.changePage(p)} color={active ? "blue" : undefined}>{p}</Button>
            buttons.push(pageButton);
        }


        if(startPageButton > 1) buttons[0] = ellipsis();
        if(endPageButton < maxPages) buttons[buttons.length - 1] = ellipsis();


        const isFirstPage = preselectedPage <= 1;
        const isLastPage = preselectedPage >= maxPages;

        const prevButton = <Button key="prev" disabled={isFirstPage} onClick={() => controller.changePage(page - 1)}>{"<<"}</Button>
        const nextButton = <Button key="prev" disabled={isLastPage} onClick={() => controller.changePage(page + 1)}>{">>"}</Button>

        return <div className="pagination padded">
            <div className="details">Showing entries <b>{range}</b> of <b>{matchedTotal}</b></div>
            <div className="buttons">{maxPages > 1 ? [ prevButton, ...buttons, nextButton ] : ""}</div>
        </div>;
    }} />;
}

function Footer({ controller }) {
    return <footer>
        <div>

        </div>
        <div>
            <Dynamic conductor={controller.notifiers.adding} child={()=>{
                const adding = controller.status.adding;
                const label = adding ? "ADDING..." : "ADD ACCOUNT";

                return <Button inProgress={adding} color="green" icon="add" onClick={() => controller.addAccount()}>{label}</Button>;
            }} />
            
        </div>
    </footer>;
}



export default Accounts;